import EvaluationsListController from './evaluationsListController';
import UserService from '../../user/services/userService';
import './evaluationsList.scss';
import DateFormatFilter from '../../../filters/dateFormat';

const EvaluationsListComponent = {
    template: require('./evaluationsListView.html'),
    controller: EvaluationsListController
};

EvaluationsListController.$inject = ['$http', '$filter', '$stateParams', '$mdDialog', '$state', 'EvaluationService', 'UserService'];

export default angular.module('app.evaluationslist', [require('angular-material-data-table')])
    .component('evaluationslist', EvaluationsListComponent)
    .filter('dateFormat', DateFormatFilter)
    .service('UserService', UserService)
    .name;


// WEBPACK FOOTER //
// ./src/app/pages/lists/evaluationsList/evaluationsListComponent.js